<template>
  <span class="ruleSortBtn">
    <el-button @click="sortClick">按规则排序</el-button>
    <el-tooltip
      class="item"
      effect="dark"
      content="排序规则取自“商品管理-商品平台配置-基础配置”中的“商品中心规格自定义排序规则"
      placement="top"
    >
      <i style="margin-left: 5px; margin-right: 5px" class="el-icon-question" />
    </el-tooltip>
  </span>
</template>

<script>
import { sortSpecifications } from '@/api/prod/center/index.js';

export default {
  name: 'ruleSortBtn',
  props: {
    // 规格信息
    specifications: {
      type: Array,
      default() {
        return [];
      },
    },
    // 当前平台
    platform: {
      type: String,
      default: '',
    },
  },
  data() {
    return {};
  },

  computed: {
    getSpValues() {
      switch (this.platform) {
        case 'tm':
          return this.tmGetValues;
        default:
          return this.commonGetValues;
      }
    },
    findValue() {
      switch (this.platform) {
        case 'tm':
          return this.tmFindValue;
        default:
          return this.commonFindValue;
      }
    },
  },
  methods: {
    // 一般获取规格值的方式
    commonGetValues(currSp) {
      let sameMap = {};
      return currSp.values.map(({ value }) => {
        if (!value) {
          throw new Error(`规格【${currSp.name}】下的规格值未完善，请补充`);
        }
        if (sameMap[value]) {
          throw new Error(`规格【${currSp.name}】下的规格值【${value}】已重复，请修改`);
        }
        sameMap[value] = true;
        return value;
      });
    },
    // 天猫获取规格值方式
    tmGetValues(currSp) {
      if (currSp.ui.type !== 'SINGLECHECK') {
        // 不是下拉框走一般获取规格值的方式
        return this.commonGetValues(currSp);
      }
      let sameMap = {};
      let options = currSp.ui.options || [];
      return currSp.values.map(({ value }) => {
        if (!value) {
          throw new Error(`规格【${currSp.name}】下的规格值未完善，请补充`);
        }
        let option = options.find(op => op.value === value);
        if (!option) {
          throw new Error(`规格【${currSp.name}】下的规格值【${value}】未找到对应选项`);
        }
        if (sameMap[option.displayName]) {
          throw new Error(`规格【${currSp.name}】下的规格值【${option.displayName}】已重复，请修改`);
        }
        sameMap[option.displayName] = true;
        return option.displayName;
      });
    },
    // 一般寻找规格值
    commonFindValue(currSp, val) {
      return currSp.values.find(({ value }) => value === val);
    },
    // 天猫寻找规格值
    tmFindValue(currSp, val) {
      if (currSp.ui.type !== 'SINGLECHECK') {
        // 不是下拉框走一般获取规格值的方式
        return this.commonFindValue(currSp, val);
      }
      let options = currSp.ui.options;
      let option = options.find(({ displayName }) => val === displayName);
      return currSp.values.find(spValue => {
        return option.value === spValue.value;
      });
    },
    async sortClick() {
      let data;
      try {
        data = this.specifications.reduce((data, curr) => {
          data.push(this.getSpValues(curr));
          return data;
        }, []);
      } catch (error) {
        console.log(error, '---error');
        this.$message.error(error.message);
        return;
      }

      const res = await sortSpecifications(data);
      // 有返回且排序发生了变化
      if (res.result === 1 && JSON.stringify(data) !== JSON.stringify(res.data)) {
        let resData = res.data;
        let newSpecifications = [];
        this.specifications.forEach((item, index) => {
          if (!resData[index]) {
            return newSpecifications.push({ ...item });
          }
          let newValues = resData[index].map(val => {
            return this.findValue(item, val);
          });
          newSpecifications.push({ ...item, values: newValues });
        });
        this.$emit('update:specifications', newSpecifications);
        this.$message.success('规格值已排序');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.ruleSortBtn {
  margin-bottom: 10px;
}
</style>